import React from "react";
import "./style.scss";
import "../../style/typography.scss";
import { useSelector } from "react-redux";
import { State } from "../../app/store";
import Seller from "./seller";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div
        className={
          saleConfiguration.widgetActive === true
            ? "iframe-footer footer flex-between flex-wrap"
            : "shop-footer footer flex-between flex-wrap"}>
        <p>
          <Seller />
        </p>







        {/* {saleConfiguration.newsLetterActive && (
          <div className="footer-block">
            <h4>{t("dolacz_do_newslettera")}</h4>
            <p>{t("chcesz_byc_na_biezaco_aby_zadna_promocja_cie_nie_ominela")}</p>
            <div className="newsletter-input-box flex-between-center">
              <input className="medium border-radius-6 border" type={"text"} placeholder={"Wpisz email"} />
              <button className="button medium padding-medium  button-fill-main">{t("dolacz")}</button>
            </div>
          </div>
        )} */}
        <div className="footer-block-full flex-center-center">
          <p>{t("dostawca_systemu_do_sprzedazy_biletow_karnetow_i_uslug_online_jest_eaktywni")}
            <a  target="_blank" href="https://www.eaktywni.pl" >
            www.eAktywni.pl
          </a></p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
